export default __webpack_public_path__ + "static/media/team-4.211819e7.png";